<div class="h-12 w-12 min-w-[3rem]">
  <pl-icon
    *ngIf="isDisabled || (isDirty && isValid); else notDisabledOrNotDirtyAndValid"
    [name]="PlIcon.tick"
    [frame]="IconFrame.round"
    class="h-full w-full"
    [ngClass]="isDisabled ? 'text-pl-gray-700' : 'text-pl-green-500'"
  />
  <ng-template #notDisabledOrNotDirtyAndValid>
    <ng-container *ngIf="isFormSubmitted; else notFormSubmitted">
      <pl-icon
        *ngIf="isDirty && !isValid"
        [name]="PlIcon.exclamation"
        [frame]="IconFrame.round"
        class="h-full w-full text-pl-error"
      />
    </ng-container>
    <ng-template #notFormSubmitted>
      <pl-icon
        *ngIf="isFocused && !isValid"
        [name]="PlIcon.chevron_back"
        [frame]="IconFrame.round"
        class="h-full w-full text-pl-blue-500"
      />
    </ng-template>
  </ng-template>
</div>
